import { useState, useRef, useEffect, useContext, useCallback } from "react";
import { DDD,
        E2Data,
        mergeDDDIAndUI,
        getInvoiceValuesFromMergedDDDIAndUI} from "../lib/ddd/ddd";
import FormWizard from "../components/formWizardOverride/FormWizard";
//import "react-form-wizard-component/dist/style.css";
import { Row, Col, Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import classes from "./IntegrationWizard.module.scss";
import JSONPretty from "../components/jsonPrettyOverride/JSONPretty";
import 'react-json-pretty/themes/monikai.css';
import { OrgIdContext } from "../store/orgId_context";
import { UserUIStateContext } from "../store/userUIStateContext";
import LoadingDots from "../components/UI/LoadingDots";
import { useQuery } from "@tanstack/react-query";
import IntegrationOverview from "../components/integrationWizard/overview/IntegrationOverview";
import IntegrationInvoice from "../components/integrationWizard/invoice/IntegrationInvoice";
import Execute from "../components/integrationWizard/execute/Execute";
import Joyride from "react-joyride";
import ActiveInvoice from "../components/integrationWizard/ActiveInvoice";
import InvoiceDisplayIframe from "../components/integrationWizard/InvoiceDisplayIframe";
import JoyrideContent from "../components/integrationWizard/JoyrideContent";
import DataObjectIcon from '@mui/icons-material/DataObject';
import StepsAndDocs from "../components/integrationWizard/StepsAndDocs";
import { Alert } from "@mui/material";
import WhatsNext from "../components/integrationWizard/overview/WhatsNext";
import { useLocation } from "react-router-dom";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);
//const ddd =  DDD.WithConnectionKey(apiRequestAddress, "b22250e5-7a48-11ee-9108-ee67f6910206");

const IntegrationWizard2 = () => {
    const [currentInvoiceId, setCurrentInvoiceId] =  useState(/*"44de78e7-94fc-11ee-9108-ee67f6910206"*/);
    const { integrationDevice, sessionInfo} = useContext(OrgIdContext);
    const [invoiceJson, setInvoiceJson] = useState();
    const [flag, setFlag] = useState();
    const [runJoyride, setRunJoyride] = useState(false);
    const [steps, setSteps] = useState([]);
    const [states, setStates] = useState({})
    const [executeRes, setExecuteRes] = useState({});
    const [invoiceMissingAlert, setInvoiceMissingAlert] = useState(false)
    const [firstRun, setFirstRun] = useState(false);
    const formWizardRef = useRef();
    const invoiceRef = useRef();
    const {saveValues, integrationData, setIntegrationDataHandler, serverDataLoaded} = useContext(UserUIStateContext);

    const location = useLocation();
    const { state } = location;
    //console.log(state);
    useEffect(() => {
        //console.log(integrationData);
    },[integrationData]);

    const handleComplete = () => {};
    const tabChanged = ({prevIndex,nextIndex,}) => {
        setRunJoyride(false);
        
        if(prevIndex === 1 && states.overviewCompleted !== true)
            setIntegrationDataHandler({...states, overviewCompleted:true});
        
        if(prevIndex === 2){
            setIntegrationDataHandler({...states, invoiceCompleted:true, invoiceJson:invoiceJson, invoiceFlag:flag});
            
            if(states.invoiceExecuteJoyrideCompleted !== true){
                setSteps(executeShow);
                setIntegrationDataHandler({...states, invoiceJson:invoiceJson, invoiceCompleted:true, invoiceFlag:flag, invoiceExecuteJoyrideCompleted:true});
                setTimeout(()=>{
                    setRunJoyride(true);
                }, 1000);
            }
        }
        if(prevIndex ===3 && states.executeCompleted !==true)
            setIntegrationDataHandler({...states, executeCompleted:true});
        if(prevIndex === 4 && states.integrationWizardCompleted !==true)
            setIntegrationDataHandler({...states, integrationWizardCompleted:true});
    }

    useEffect(() =>{
        if(!integrationData && serverDataLoaded)
            setIntegrationDataHandler({...states, firstRun:true});

        if(!integrationData)
            return;

        if(firstRun === false){
            setFirstRun(true);
            goToActiveStepFromIntegrationData();
        }
        //console.log(sessionInfo);
        if(!invoiceJson && integrationData.invoiceJson)
            setInvoiceJson(integrationData.invoiceJson)
        if(!currentInvoiceId && integrationData.currentInvoiceId)
            setCurrentInvoiceId(integrationData.currentInvoiceId);
        if(!flag && integrationData.invoiceFlag)
            setFlag(integrationData.invoiceFlag);
        if(!flag && !integrationData.invoiceFlag)
            setFlag(sessionInfo?.Extended?.CountryCode?.toLowerCase());

        setStates({...integrationData});
    },[integrationData,serverDataLoaded]);

    const goToActiveStepFromIntegrationData = () => {
        if(state?.activeTab === "edit") return formWizardRef.current.goToTab(1);
        
        if(integrationData.integrationWizardCompleted ===true){
            formWizardRef.current.goToTab(4);
        }else if(integrationData.executeCompleted  ===true){
            formWizardRef.current.goToTab(3);
        }else if(integrationData.invoiceCompleted  ===true){
            formWizardRef.current.goToTab(2);
        }else if(integrationData.overviewCompleted  ===true){
            formWizardRef.current.goToTab(1);
        }
    }
    
    const {isPending : isMinimalPending, data : minimalData} = useQuery({
        queryKey: ['APP_GetNewDDDIAndUIMerged', "Normal", "IncludeInfo", "EditableOnly", integrationDevice],
        queryFn: () => DDD.WithConnectionKey(apiRequestAddress, integrationDevice).APP_GetNewDDDIAndUIMerged({Complexity: "Normal", IncludeInfo : true}, {Complexity: "Normal", EditableOnly: true}),
        staleTime: Infinity,
        enabled : integrationDevice!==null && integrationDevice!==undefined,
        refetchOnWindowFocus:false
    })

    const onJsonChanged = (json) =>{
        if(currentInvoiceId){
            setInvoiceJson({...json, "Object": {Id: currentInvoiceId, ...json.Object}})
        }
        else
            setInvoiceJson(json);
    }

    const onFlagChanged = (data) =>{
        setFlag(data);
    }

    const validateForm = () =>{
        if(!invoiceRef)
            return true;
        return invoiceRef.current.validate();
    }

    const validateInvoice = () =>{
        if(currentInvoiceId)
            return true;

        setInvoiceMissingAlert(true);
        setTimeout(()=>{
            setInvoiceMissingAlert(false);
        }, 5000);
    }

    const onExecute = (res) => {
        setExecuteRes(res);
        setRunJoyride(false);
        if(res && res.Status === "Error" && !res.Id && states.invoiceErrorJoyrideCompleted !== true){
            setSteps(executeErrorSteps);
            //saveValues({integrationData: {...states, invoiceErrorJoyrideCompleted:true}});
            setIntegrationDataHandler({...states, invoiceErrorJoyrideCompleted:true});
            setTimeout(()=>{
                setRunJoyride(true);
            }, 1000);
        }else if(res && res.Id){
            if(!currentInvoiceId){

                if(!states.invoiceCreatedJoyrideCompleted){
                    setSteps(invoiceCreated);
                    setTimeout(()=>{
                        setRunJoyride(true);
                    }, 1000);
                }

                setCurrentInvoiceId(res.Id);
                setInvoiceJson({...invoiceJson, "Object": {Id: res.Id, ...invoiceJson.Object}})
                setIntegrationDataHandler({...states, currentInvoiceId:res.Id, invoiceCreatedJoyrideCompleted:true});
            }
        }
    }

    const onInvoiceLoaded = () =>{
        if(executeRes.Status==="Error" && states.invoiceValidationJoyrideCompleted!==true){
            setIntegrationDataHandler({...states, invoiceValidationJoyrideCompleted:true});
            setSteps(formValidationSteps);
            setTimeout(()=>{
                setRunJoyride(true);
            }, 1000);
        }else if(!states.invoiceJoyrideCompleted){
            setIntegrationDataHandler({...states, overviewCompleted:true, invoiceJoyrideCompleted:true});
            setSteps(invoiceSteps);
            setTimeout(()=>{
                setRunJoyride(true);
            }, 1000);
        }
    }



    const onCreateNewInvoice = () =>{
        let tmp = JSON.parse(JSON.stringify(invoiceJson));
        delete tmp?.Object?.Id;
        setIntegrationDataHandler({...integrationData, currentInvoiceId : null, invoiceJson:tmp})
        setCurrentInvoiceId(null)
        setInvoiceJson(tmp);
        formWizardRef.current.goToTab(1);
    }
    let invoiceSteps = [
        {
            target : "#invoiceJson",
            content : <JoyrideContent content={<span>This is the JSON object we will send to <span style={{textDecoration:"underline"}}>DDDI_Save</span> API for creation of an invoice</span>} icon={<DataObjectIcon/>} title={"About object"}/>,
            disableBeacon : true
        },
        {
            target : "#invoiceForm",
            content : <JoyrideContent content={<span>To make changes to the JSON object, use the form below. Insert your invoice information</span>} title={"Edit object"}/>,
            //content : "To make changes to the JSON object, use the form below. Insert your invoice information",
            disableBeacon : true
        },
        {
            target : "#dummyData",
            content : <JoyrideContent content={<span>If you wish to skip quickly to creation of a new invoice click here to fill the form with dummy data.</span>} title={"Prefill form"}/>,
            disableBeacon : true
        },
        {
            target : "#invoiceInput",
            content : <JoyrideContent content={<span>If you wish to enter your data as you would in a real invoice, click here where input fields will be displayed as an invoice.</span>} title={"Show form as an Invoice"}/>,
            disableBeacon : true
        },
    ]

    const executeShow = [
        {
            target : "#curlCmd",
            content : <JoyrideContent content={<span>This is the expression that we will be executing. This is an example of what you would be executing in your solutions.</span>} icon={<DataObjectIcon/>} title={"Expression"}/>,
            disableBeacon : true
        },
        {
            target : "#executeBtn",
            content : <JoyrideContent content={<span>Click execute</span>} title={"Execute"}/>,
            //content : "To make changes to the JSON object, use the form below. Insert your invoice information",
            disableBeacon : true
        },
    ]

    const executeErrorSteps =[
        {
            target: "#execute-json-response",
            //content : "Because the invoice resulted in an error, repair some information first",
            content : <JoyrideContent content={<span>Because the invoice resulted in an error, we need to repair some information first</span>} title={"Invoice save error"}/>,
            disableBeacon : true
        },
        {
            target: "#wizard-back",
            content : <JoyrideContent content={<span>Click back, to edit invoice information</span>} title={""}/>,
            //content : "Click back, to edit invoice information",
            disableBeacon : true
        }
    ]
    const formValidationSteps=[
        {
            target: "#enableValidation",
            content : <JoyrideContent content={<span>For faster correction of input information, you can enable client side validation here</span>} title={"Enable validation?"}/>,
            //content : "For faster correction of input information, you can enable client side validation here",
            disableBeacon : true
        },
    ]
    const invoiceCreated=[
        {
            target: "#activeInvoice",
            content : <JoyrideContent content={<span>A new invoice has been created. From now on, we will edit/operate upon an existing invoice using its Id</span>} title={"Invoice created"}/>,
            //content : "A new invoice has been created. From now on, we will edit/operate upon an existing invoice using its Id",
            disableBeacon : true
        },
        {
            target: "#executePrettyScroll",
            content : <JoyrideContent content={<span>All the subsquent requests will be accompanied by a parameter "Id"</span>} title={"Future requests"}/>,
            //content : 'All the subsquent requests will be accompanied by a parameter "Id"',
            disableBeacon : true
        },
        {
            target: "#activeInvoiceBtn",
            content : <JoyrideContent content={<span>If you wish to create a new invoice, click here</span>} title={"Reset invoice"}/>,
            //content : 'If you wish to create a new invoice, click here',
            disableBeacon : true
        },
        {
            target: "#wizard-forward",
            content : <JoyrideContent content={<span>Continue to view the newly created invoice</span>} title={"View invoice"}/>,
            disableBeacon : true
        },
    ]

    return(
        <>
        <Helmet>
            <title>Integration | DDD Invoices</title>
        </Helmet>
{runJoyride &&        <Joyride 
            steps={steps} 
            run={runJoyride}
            continuous
            scrollToFirstStep
            disableScrollParentFix
            locale={{last:"Close"}}
            styles={{
                options: {
                    zIndex: 10000,
                    arrowColor: '#df511d',
                    textColor: '#005683',
                    primaryColor: "#005683"
                }
            }}
            />}
        <div className={`w-100 ${classes.container} ${classes["p-lrb-5"]}`}>
            <FormWizard
                onComplete={handleComplete}
                onTabChange={tabChanged}
                ref={formWizardRef}
                finishButtonTemplate={function(){}}
                >
                <FormWizard.TabContent title="Overview" icon="ti-info" >
                    {/* {currentInvoiceId && <ActiveInvoice invoiceId={currentInvoiceId}/>} */}
                    <IntegrationOverview/>
                    
                </FormWizard.TabContent>
                <FormWizard.TabContent 
                      title="Invoice" 
                      icon="ti-credit-card" 
                      _isValid = {validateForm}
                      _onValidationError = {null}
                    >
                    {currentInvoiceId && <ActiveInvoice invoiceId={currentInvoiceId} onCreateNew={onCreateNewInvoice} style={{marginBottom:"1rem"}}/>}
                    <IntegrationInvoice flag={flag} onFlagChanged={onFlagChanged} onJsonChanged={onJsonChanged} ref={invoiceRef} onLoaded={onInvoiceLoaded} json={invoiceJson} invoiceId={currentInvoiceId}/>
                </FormWizard.TabContent>
                <FormWizard.TabContent title="Execute" icon="ti-cloud-up" _isValid = {validateInvoice}>
                    {currentInvoiceId && <ActiveInvoice invoiceId={currentInvoiceId} onCreateNew={onCreateNewInvoice} style={{marginBottom:"1rem"}}/>}
                    <Execute json={invoiceJson} onExecute={onExecute} invoiceId={currentInvoiceId}/>
                    {invoiceMissingAlert && <><Alert style={{margin:"2rem"}} severity="error">You must first create an Invoice</Alert></>}
                </FormWizard.TabContent>
                <FormWizard.TabContent title="View" icon="ti-receipt">
                    {currentInvoiceId && <ActiveInvoice invoiceId={currentInvoiceId} onCreateNew={onCreateNewInvoice} style={{marginBottom:"1rem"}}/>}
                    <div style={{height:"60vh"}}><InvoiceDisplayIframe invoiceId={currentInvoiceId}/></div>
                </FormWizard.TabContent>
                {/* <FormWizard.TabContent title="Steps&Docs" icon="ti-cloud-up">
                    {currentInvoiceId && <ActiveInvoice invoiceId={currentInvoiceId} onCreateNew={onCreateNewInvoice} style={{marginBottom:"1rem"}}/>}
                    <StepsAndDocs invoiceId={currentInvoiceId}/>
                </FormWizard.TabContent> */}
                <FormWizard.TabContent title="What's next" icon="ti-help">
                    {currentInvoiceId && <ActiveInvoice invoiceId={currentInvoiceId} onCreateNew={onCreateNewInvoice} style={{marginBottom:"1rem"}}/>}
                    <WhatsNext/>
                </FormWizard.TabContent>
            </FormWizard>
        </div>
        <style>{`
            @import url("https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@0.1.2/css/themify-icons.css");
        `}</style>
        </>
    )
}
export default IntegrationWizard2;